module.exports = __webpack_public_path__ + "static/media/logo putih.9e69f2a7.png";